import { Injectable } from '@angular/core';
import type { Logger } from 'loglevel';

import type { AppLogger } from './app-logger';
import type { LogMeta } from './logging.config';
import { LoggerFactoryService } from './logger-factory.service';

@Injectable({ providedIn: 'root' })
export class AppLoggerService {
  constructor(private readonly loggerFactory: LoggerFactoryService) {}

  create(context: string): AppLogger {
    return this.wrap(this.loggerFactory.create(context));
  }

  createForClass(clazz: Function): AppLogger {
    return this.wrap(this.loggerFactory.createForClass(clazz));
  }


  private wrap(logger: Logger): AppLogger {
    const hasMeta = (meta: LogMeta | undefined): meta is LogMeta => meta !== undefined;

    return {

      trace: (message: string, meta?: LogMeta) => (hasMeta(meta) ? logger.trace(message, meta) : logger.trace(message)),
      debug: (message: string, meta?: LogMeta) => (hasMeta(meta) ? logger.debug(message, meta) : logger.debug(message)),
      info: (message: string, meta?: LogMeta) => (hasMeta(meta) ? logger.info(message, meta) : logger.info(message)),
      warn: (message: string, meta?: LogMeta) => (hasMeta(meta) ? logger.warn(message, meta) : logger.warn(message)),

      /**
       * Konsistente Signatur: message, error, meta
       * WICHTIG: meta/fehler nur übergeben, wenn vorhanden, um keine "undefined"-Argumente ins Log zu bekommen.
       */
      error: (message: string, error?: unknown, meta?: LogMeta) => {
        // Keep error objects inspectable in devtools.
        const errArg = error instanceof Error ? error : error;

        if (!hasMeta(meta) && error === undefined) {
          logger.error(message);
          return;
        }
        if (!hasMeta(meta)) {
          logger.error(message, errArg);
          return;
        }
        if (error === undefined) {
          logger.error(message, meta);
          return;
        }
        logger.error(message, meta, errArg);
      },
    };
  }
}
